import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const AdminLayout = lazy(() => import("@/features/admin/layout/AdminLayout"));
const AdminDashboard = lazy(() => import("@/features/admin/pages/Dashboard"));
const AdminRestaurants = lazy(() => import("@/features/admin/pages/Restaurants"));
const AdminUsers = lazy(() => import("@/features/admin/pages/Users"));
const AdminOrders = lazy(() => import("@/features/admin/pages/Orders"));
const AdminAnalytics = lazy(() => import("@/features/admin/pages/Analytics"));
const AdminSettings = lazy(() => import("@/features/admin/pages/Settings"));
const AdminLoyalty = lazy(() => import("@/features/admin/pages/Loyalty"));
const AdminReports = lazy(() => import("@/features/admin/pages/Reports"));
const AdminCampaignApproval = lazy(() => import("@/features/admin/pages/CampaignApproval"));
const AdminReviewManagement = lazy(() => import("@/features/admin/pages/ReviewManagement"));

export const adminRoutes = (
  <>
    <Route path="/admin" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminDashboard /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/restaurants" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminRestaurants /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/users" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminUsers /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/orders" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminOrders /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/analytics" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminAnalytics /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/campaigns" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminCampaignApproval /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/loyalty" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminLoyalty /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/reports" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminReports /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/settings" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminSettings /></AdminLayout>
      </ProtectedRoute>
    } />
    <Route path="/admin/reviews" element={
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLayout><AdminReviewManagement /></AdminLayout>
      </ProtectedRoute>
    } />
  </>
);
